
import './scss/style.scss';

import { Application } from "./app/Application";

let app = new Application();


// WEBPACK FOOTER //
// /Users/pgaultier/Dev/gan-patrimoine-prospection/node_modules/source-map-loader!./main.ts